
import { Component } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import {MatTabsModule} from '@angular/material/tabs';
import { CommonTableComponent } from '../../common/common-table/common-table.component';

@Component({
  selector: 'app-simulations-search',
  standalone: true,
  imports: [MatTabsModule, MatCardModule, CommonTableComponent],
  templateUrl: './simulations-search.component.html',
  styleUrl: './simulations-search.component.scss'
})
export class SimulationsSearchComponent {

}
